"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITeamFrozen = exports.ITeamInactive = exports.ITeamAutocascadedisabled = void 0;
var ITeamAutocascadedisabled;
(function (ITeamAutocascadedisabled) {
    ITeamAutocascadedisabled[ITeamAutocascadedisabled["ENABLED_0"] = 0] = "ENABLED_0";
    ITeamAutocascadedisabled[ITeamAutocascadedisabled["DISABLED_1"] = 1] = "DISABLED_1";
})(ITeamAutocascadedisabled = exports.ITeamAutocascadedisabled || (exports.ITeamAutocascadedisabled = {}));
var ITeamInactive;
(function (ITeamInactive) {
    ITeamInactive[ITeamInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    ITeamInactive[ITeamInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(ITeamInactive = exports.ITeamInactive || (exports.ITeamInactive = {}));
var ITeamFrozen;
(function (ITeamFrozen) {
    ITeamFrozen[ITeamFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    ITeamFrozen[ITeamFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(ITeamFrozen = exports.ITeamFrozen || (exports.ITeamFrozen = {}));
